import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';

// Redirect legacy preview route to the read-only profile canvas
export const ProfilePreviewCanvas: React.FC = () => {
  const { id = '' } = useParams();
  const navigate = useNavigate();

  React.useEffect(() => {
    if (id) {
      navigate(`/canvas?profileId=${encodeURIComponent(id)}`, { replace: true });
    } else {
      navigate('/market', { replace: true });
    }
  }, [id, navigate]);

  return null;
};
